module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(_vm.isConnected) ? _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle clickable",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.user
    }
  })], 1), _c('ul', {
    staticClass: "dropdown-menu nopadding"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.user,
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/profile/avatar')
      }
    }
  }), (_vm.user) ? _c('p', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/profile/info')
      }
    }
  }, [_vm._v(_vm._s(_vm.user.name)), _c('small', [_vm._v(_vm._s(_vm.$t('headerUserDropdown.memberSince')) + " " + _vm._s(_vm._f("unixtimeTo")(_vm.user.creationTime, 'L')))])]) : _vm._e()], 1), _c('li', {
    staticClass: "user-body",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.showContacts
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" " + _vm._s(_vm.$t('sidemenu.contacts')))])]), _c('li', {
    staticClass: "user-body",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.showHelp
    }
  }, [_c('a', {
    staticClass: "clickable"
  }, [_c('i', {
    staticClass: "fa fa-question"
  }), _vm._v(" " + _vm._s(_vm.$t('sidemenu.help')))])]), _c('li', {
    staticClass: "user-body",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.showKeyshortcuts
    }
  }, [_c('a', {
    staticClass: "clickable"
  }, [_c('i', {
    staticClass: "fa fa-keyboard-o"
  }), _vm._v(" " + _vm._s(_vm.$t('headerUserDropdown.keyShortcuts')))])]), _c('router-link', {
    staticClass: "user-body",
    attrs: {
      "tag": "li",
      "to": "/profile",
      "role": "button"
    }
  }, [_c('a', {
    staticClass: "clickable"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" " + _vm._s(_vm.$t('headerUserDropdown.profile')))])]), _c('li', {
    staticClass: "user-body",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('a', {
    staticClass: "clickable"
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" " + _vm._s(_vm.$t('headerUserDropdown.deconnect')))])])], 1)]) : _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.connect
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('headerUserDropdown.connect')) + "  ")]), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profileImage user"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-183c1eca","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainWrapper/HeaderUserDropdown.vue
// module id = 1249
// module chunks = 1